/* global JQuery */
import { Lang } from '../../Lang';
import { ButtonClass2, ButtonDefault2, FormGroup2, FormRow2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2 } from 'bambooo';
import moment from 'moment';
/**
 * Modal that lets an admin pick the target tour for transferring a
 * brushed range of tracking points. Auto-fills with previous/next
 * tours of the same vehicle when available; otherwise the admin can
 * type a Tour-ID by hand.
 */
export class TransferModal extends ModalDialog2 {
    constructor(elementObject) {
        super({
            id: 'tourstrackingtransfermodal',
            modalType: ModalDialogType2.large,
            target: TransferModal._asTarget(elementObject)
        });
        this._onConfirm = null;
        this.setTitle(new LangTextV2({ text: 'Transfer tracking points' }));
        const body = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        this._rangeInfo = jQuery('<div class="text-muted small pb-2"/>').appendTo(body);
        const escape = (s) => s.replace(/[&<>"']/gu, (ch) => { var _a; return (_a = ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' })[ch]) !== null && _a !== void 0 ? _a : ch; });
        const radioName = `tourstrackingtransfer-${Math.random().toString(36).slice(2, 8)}`;
        const prevWrap = jQuery('<div class="form-check"/>').appendTo(body);
        this._radioPrev = jQuery(`<input class="form-check-input" type="radio" name="${escape(radioName)}" value="prev" disabled>`).appendTo(prevWrap);
        jQuery('<label class="form-check-label"/>').text(Lang.i().l('Previous tour (no candidate)')).appendTo(prevWrap);
        const nextWrap = jQuery('<div class="form-check"/>').appendTo(body);
        this._radioNext = jQuery(`<input class="form-check-input" type="radio" name="${escape(radioName)}" value="next" disabled>`).appendTo(nextWrap);
        jQuery('<label class="form-check-label"/>').text(Lang.i().l('Next tour (no candidate)')).appendTo(nextWrap);
        const manualWrap = jQuery('<div class="form-check"/>').appendTo(body);
        this._radioManual = jQuery(`<input class="form-check-input" type="radio" name="${escape(radioName)}" value="manual">`).appendTo(manualWrap);
        jQuery('<label class="form-check-label"/>').text(Lang.i().l('Other tour by ID')).appendTo(manualWrap);
        const row = new FormRow2({});
        row.appendTo(body);
        const groupManual = new FormGroup2({ label: new LangTextV2({ text: 'Tour ID' }) });
        groupManual.appendTo(row.createCol(4));
        this._inputManual = new Input2({ type: InputType2.number });
        this._inputManual.appendTo(groupManual);
        this._inputManual.setPlaceholder('e.g. 12345');
        this.addButtonClose(Lang.i().l('Close'));
        this._btnConfirm = new ButtonDefault2({
            title: Lang.i().l('Transfer'),
            icon: 'fas fa-exchange-alt',
            btnClass: ButtonClass2.primary
        });
        this._btnConfirm.appendTo(this.getFooter());
        this._btnConfirm.setOnClickFn(() => {
            const targetId = this._resolveTargetId();
            if (targetId <= 0) {
                return;
            }
            if (this._onConfirm) {
                this._onConfirm(targetId);
            }
        });
        const updateState = () => this._updateConfirmEnabled();
        this._radioPrev.on('change', updateState);
        this._radioNext.on('change', updateState);
        this._radioManual.on('change', updateState);
        this._inputManual.getElement().on('input', updateState);
        this._updateConfirmEnabled();
    }
    setRange(timestampFrom, timestampTo, count) {
        const from = moment(timestampFrom).format('YYYY-MM-DD HH:mm:ss');
        const to = moment(timestampTo).format('YYYY-MM-DD HH:mm:ss');
        this._rangeInfo.text(`Range: ${from} → ${to} · ${count} points`);
    }
    setNeighbors(prev, next) {
        this._prev = prev;
        this._next = next;
        const fmtLabel = (label, n) => {
            if (!n) {
                return `${label} (no candidate)`;
            }
            const range = n.tour_start && n.tour_end ? ` ${n.tour_start}–${n.tour_end}` : '';
            return `${label}: #${n.id} · ${n.date}${range} · ${n.count_trackings} pts`;
        };
        this._radioPrev.next('label').text(fmtLabel('Previous tour', prev));
        this._radioNext.next('label').text(fmtLabel('Next tour', next));
        if (prev) {
            this._radioPrev.removeAttr('disabled');
        }
        else {
            this._radioPrev.attr('disabled', 'disabled').prop('checked', false);
        }
        if (next) {
            this._radioNext.removeAttr('disabled');
        }
        else {
            this._radioNext.attr('disabled', 'disabled').prop('checked', false);
        }
        // Preselect the better candidate if exactly one is offered.
        if (prev && !next) {
            this._radioPrev.prop('checked', true);
        }
        else if (next && !prev) {
            this._radioNext.prop('checked', true);
        }
        this._updateConfirmEnabled();
    }
    setOnConfirm(fn) {
        this._onConfirm = fn;
    }
    resetValues() {
        this._prev = undefined;
        this._next = undefined;
        this._radioPrev.prop('checked', false).attr('disabled', 'disabled');
        this._radioNext.prop('checked', false).attr('disabled', 'disabled');
        this._radioManual.prop('checked', false);
        this._inputManual.setValue('');
        this._rangeInfo.text('');
        this._updateConfirmEnabled();
    }
    _resolveTargetId() {
        if (this._radioPrev.is(':checked') && this._prev) {
            return this._prev.id;
        }
        if (this._radioNext.is(':checked') && this._next) {
            return this._next.id;
        }
        if (this._radioManual.is(':checked')) {
            const n = parseInt(this._inputManual.getValue(), 10);
            return Number.isFinite(n) && n > 0 ? n : 0;
        }
        return 0;
    }
    _updateConfirmEnabled() {
        const id = this._resolveTargetId();
        const el = this._btnConfirm.getElement();
        if (id > 0) {
            el.removeAttr('disabled');
        }
        else {
            el.attr('disabled', 'disabled');
        }
    }
    /**
     * Resolve the constructor argument (bambooo component, jQuery or selector)
     * to a jQuery handle the modal can be mounted into.
     * @param {ComponentType} element
     * @return {JQuery}
     * @protected
     */
    static _asTarget(element) {
        const maybe = element;
        if (maybe && typeof maybe.getElement === 'function') {
            return maybe.getElement();
        }
        return jQuery(element);
    }
}
